import { inject, provideAppInitializer } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { SvgIcons } from '@shared/svg-icons/svg-icons';

export function registerSvgIcons(): Promise<void> {
  const matIconRegistry = inject(MatIconRegistry);
  const sanitizer = inject(DomSanitizer);

  Object.keys(SvgIcons)
    .filter(x => isNaN(+x))
    .forEach(iconName => {
      matIconRegistry.addSvgIcon(
        iconName,
        sanitizer.bypassSecurityTrustResourceUrl(
          `/assets/icons/material/${iconName}.svg`
        )
      );
    });

  return Promise.resolve();
}

export const SVG_ICONS_INITIALIZER = provideAppInitializer(() =>
  registerSvgIcons()
);
